import { useQuery } from '@tanstack/react-query'
import { fetchExperiment } from './api'
const moment = require('moment')

const tryValidateSubscriptionConfig = (config) => {
  return (config?.paymentType === 'SUBSCRIPTION')
    ? (!!config?.billingPlanPublicId && !!config?.billingPlanType)
    : true
}

const checkIfActive = (experiment) => {
  return (
    experiment?.experimentType === 'BOOK_AND_JOIN' &&
    experiment?.isEnabled &&
    new Date() <= new Date(experiment?.config?.endDate) &&
    tryValidateSubscriptionConfig(experiment?.config)
  )
}

const generateBookingSlots = (config) => {
  if (!config) return []

  const slots = []
  const startDate = moment(config.startDate)
  const endDate = moment(config.endDate)
  const duration = config.appointmentDurationInMinutes || 30
  const includeWeekends = config.includeWeekends ?? false

  for (let date = startDate.clone(); date.isSameOrBefore(endDate, 'day'); date.add(1, 'day')) {
    const dayOfWeek = date.day()

    if (!includeWeekends && (dayOfWeek === 0 || dayOfWeek === 6)) continue

    const dayStart = moment(`${date.format('YYYY-MM-DD')}T${config.startTime}`)
    const dayEnd = moment(`${date.format('YYYY-MM-DD')}T${config.endTime}`)

    for (let slotStart = dayStart.clone(); slotStart.isBefore(dayEnd); slotStart.add(duration, 'minutes')) {
      slots.push({
        localDate: date.format('YYYY-MM-DD'),
        startDateTimeLocal: slotStart.format('YYYY-MM-DDTHH:mm:ss')
      })
    }
  }

  return slots
}

export const useFetchExperiment = ({ externalId }) => {
  const { data: experiment, isLoading, isRefetching } = useQuery({
    queryKey: ['fetchExperiment', externalId],
    queryFn: async () => {
      await new Promise(resolve => setTimeout(resolve, 300))
      return await fetchExperiment({ externalId })
    },
    enabled: !!externalId,
    retry: 3
  })

  return {
    experiment,
    isLoadingExperiment: isLoading || isRefetching,
    isExperimentActive: checkIfActive(experiment),
    bookingSlots: generateBookingSlots(experiment?.config)
  }
}
